/*
 * Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

//https://register.bz-uk.roamingowl.com/widgets/dp-gallery/bc3ebc3c-253e-43a9-9243-a763708d013g

import ServerRequest from "./server-request";
import urlJoin from "proper-url-join";

const getGalleryData = async galleryId => {
  let request = new ServerRequest(
    urlJoin(
      `https://register.bz-uk.roamingowl.com/widgets/dp-gallery/${galleryId}`
    )
  );
  let { data } = await request.post({
    apiKey: "mdDIUVkJ0AyFNA23UF0J0ztA8r72kbXe"
  });
  return data;
};

const GalleryDataService = {
  getGalleryData
};

export default GalleryDataService;
export { getGalleryData };
